import React from 'react';
import { getHeaderWithTooltip } from './HeaderTooltip';

const FailedMarkingUI = ({ failedMarkings }) => {
  if (
    !(
      failedMarkings?.userIds?.length > 0 ||
      failedMarkings?.cartIds?.length > 0 ||
      Object.keys(failedMarkings?.actions || {}).length > 0
    )
  ) {
    return null;
  }

  return (
    <div className='tw-mt-8 tw-flex tw-flex-col tw-gap-1'>
      {getHeaderWithTooltip(
        '⚠️ Failed Fraud Markings',
        'These User IDs and Cart IDs could not be marked as fraud',
      )}
      <div className='tw-flex tw-flex-col tw-gap-2 tw-p-4 tw-border-solid tw-border-[2px] tw-border-red-300 tw-bg-red-100/30 tw-rounded-lg'>
        {failedMarkings.userIds?.length > 0 && (
          <div className='tw-flex tw-flex-col'>
            <div className='tw-font-medium tw-text-grey-800'>
              All Fraud Markings have been failed for these User IDs:
            </div>
            {
              <div className='tw-py-4 tw-flex tw-items-center tw-flex-wrap tw-gap-2 tw-text-grey-600'>
                {failedMarkings.userIds.map((userId) => (
                  <span
                    key={userId}
                    className='tw-block tw-rounded-full tw-bg-grey-200/70 tw-px-3 tw-py-1 tw-text-sm tw-font-medium'
                  >
                    {userId}
                  </span>
                ))}
              </div>
            }
          </div>
        )}
        {failedMarkings.cartIds?.length > 0 && (
          <div className='tw-flex tw-flex-col tw-gap-1 tw-mt-2'>
            <div className='tw-font-medium tw-text-grey-800'>
              All Fraud Markings have been failed for these Cart IDs:
            </div>
            {
              <div className='tw-py-4 tw-flex tw-items-center tw-flex-wrap tw-gap-2 tw-text-grey-600'>
                {failedMarkings.cartIds.map((cartId) => (
                  <span
                    key={cartId}
                    className='tw-block tw-rounded-full tw-bg-grey-200/70 tw-px-3 tw-py-1 tw-text-sm tw-font-medium'
                  >
                    {cartId}
                  </span>
                ))}
              </div>
            }
          </div>
        )}
        {Object.keys(failedMarkings.actions || {}).length > 0 && (
          <div className='tw-flex tw-flex-col tw-gap-1 tw-mt-6'>
            <div className='tw-font-medium tw-text-grey-800'>
              Specific Markings have been failed for respective User IDs and
              Cart IDs:
            </div>
            <div className='tw-flex tw-flex-col tw-gap-2'>
              {Object.entries(failedMarkings.actions).map(
                ([userId, cartIdObj]) => (
                  <div
                    key={userId}
                    className='tw-text-grey-800 tw-mt-2 tw-flex tw-flex-col tw-border-solid tw-border-[1px] tw-border-grey-200 tw-p-4 tw-rounded-lg tw-bg-white'
                  >
                    <span>
                      <div className='tw-font-medium'>User ID: {userId}</div>
                      <div className='tw-flex tw-flex-col tw-gap-3 tw-mt-2'>
                        {Object.keys(cartIdObj || {})?.map((cartID) => {
                          return (
                            <span
                              key={cartID}
                              className='tw-p-3 tw-rounded-lg tw-bg- tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-4 tw-bg-grey-100/80'
                            >
                              Cart ID: {cartID}
                              <div className='tw-flex tw-items-center tw-flex-wrap tw-gap-2 tw-text-grey-600'>
                                {cartIdObj?.[cartID]?.map((param) => (
                                  <span
                                    key={param}
                                    className='tw-block tw-rounded-full tw-bg-grey-200/70 tw-px-3 tw-py-1 tw-text-sm tw-font-medium'
                                  >
                                    {param}
                                  </span>
                                ))}
                              </div>
                            </span>
                          );
                        })}
                      </div>
                    </span>
                  </div>
                ),
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FailedMarkingUI;
